
import React from 'react'

import { useLocation, Link } from 'react-router-dom';
import MealForm from "../../components/Form/MealForm";


export default function EditMealMaster() {

    const location = useLocation();
    const detail = location.state;

  return (
    <div className="p-4">
        <div className="flex justify-between items-center py-4 px-6">
            <h1 className="text-lg sm:text-xl md:text-xl lg:text-xl xl:text-2xl font-bold">Meal master Edit</h1>
            <div>
                <Link to="/item_category/add" target='_blank'>
                    <button className="px-4 py-2 bg-blue-500 text-white rounded-md mr-4 hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-200">Add Item Category</button>
                </Link>
                <Link to="/consumption_master/list" target='_blank'>
                    <button className="px-4 py-2 bg-blue-500 text-white rounded-md mr-4 hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-200">Consumption Master</button>
                </Link>
                <Link to="/item/add" target='_blank'>
                    <button className="px-4 py-2 bg-blue-500 text-white rounded-md mr-4 hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-200">Add Item</button>
                </Link>
                <Link to="/meal_master/list">
                    <button className="px-4 py-2 bg-blue-500 text-white rounded-md mr-4 hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-200">Back</button>
                </Link>
            </div>
        </div>
        <div className="relative overflow-x-auto shadow-md sm:rounded-lg px-4 py-2">
           <MealForm detail={detail} />
        </div>
    </div>
  )
}
